module.exports = __webpack_public_path__ + "static/media/cross.148d6adf.svg";